import { render, staticRenderFns } from "./ProgressAnswer.vue?vue&type=template&id=483763e5&scoped=true&"
import script from "./ProgressAnswer.vue?vue&type=script&lang=ts&"
export * from "./ProgressAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressAnswer.vue?vue&type=style&index=0&id=483763e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483763e5",
  null
  
)

export default component.exports